import React from 'react';

import classes from './StopoverWrapper.scss';

const stopoverWrapper = (props) => (
    <div className={classes.Wrap}>
        {props.children}
    </div>
);

export default stopoverWrapper;


// WEBPACK FOOTER //
// ./src/components/Flight/Wrappers/StopoverWrapper/StopoverWrapper.js